module.exports = __webpack_public_path__ + "static/media/upload-document-anyotherpaper-mobile.45cfa579.png";